export default {
  FlightInvalid__INVALID_FLIGHT_ARIA: (data) => `${data.INVALID_RESPONSE}`,
};
